import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import _ from 'lodash';
import ArticleHerocontainer from '../container/ArticleHerocontainer.js';
import ArticleHeadercontainer from '../container/ArticleHeadercontainer.js';
import Headercontainer from '../container/Headercontainer.js';
import ArticleMaincontainer from '../container/ArticleMaincontainer.js';
import ArticleRating from '../container/ArticleRating.js';
import Breadcrumbcontainer from '../container/Breadcrumbcontainer.js';
import Faqcomponent from '../container/Faqcomponent.js';
import Relatedstories from '../container/Relatedstories.js';
import SidePanelcomponent from '../container/SidePanelcomponent.js';
import Socialcontainer from '../container/Socialcontainer.js';
import ArticleFootNotecontainer from '../container/ArticleFootNotecontainer.js';
import Footercontainer from '../container/Footercontainer.js';
import Helpcontainer from '../container/Helpcontainer.js';
import Scrollupcontainer from '../container/Scrollupcontainer.js';
import MostPopularArticles from '../container/MostPopularArticles';
import LegalFooter from '../container/LegalFooter.js';
import GatewayDownload from '../container/GatewayDownload.js';
import GatewayForm from '../container/GatewayForm.js';
import Podcast from '../container/Podcast.js';
import { isTypePodcast } from '../lib/podcastHelper';
import FormLessForm from '../container/FormLessForm';
import {
  isPardotTrueExistInUrl,
  checkSlugIdExist,
  getPardotUrlForSelectedSlugId,
} from '../lib/gatewayFormHelper';

class ArticleMainComponent extends Component {
  static getPage(url) {
    if (url.includes('/topics/')) {
      return 'Category Page';
    } else if (url.length === 0) {
      return null;
    }
    return 'Home Page';
  }

  static getCSRFToken() {
    const body = document.getElementsByTagName('body')[0];
    const csrfToken = body.getAttribute('data-token');
    return csrfToken;
  }

  constructor(props) {
    super(props);
    this.state = {
      cookies: '',
      attachUrl: '',
      pdtmail: '',
      urlPath: '',
    };
  }

  componentDidMount() {
    const hrefUrl = window.location.href;

    if (hrefUrl.indexOf('pdtmail=') !== -1) {
      const params = hrefUrl
        .split('?')[1]
        .split('&')
        .filter((s) => s.indexOf('pdtmail') > -1)[0];
      this.setState({
        pdtmail: params.split('=')[1],
      });
    }
    if (hrefUrl.indexOf('?locale.x') !== -1) {
      this.setState({
        attachUrl: hrefUrl.split('?')[1],
      });
    }
    this.setState({
      cookies: document.cookie,
      urlPath: window.location.href,
    });
    const articleInfo = JSON.parse(this.props.articleInfo);

    const self = this;
    const localePart = this.props.locale.split('_')[0];
    let locale;
    if (this.props.country === 'UK') {
      locale = this.props.locale;
    } else {
      locale = `${localePart}_${this.props.country.toUpperCase()}`;
    }

    if (_.isString(locale) && locale.length < 6) {
      const body = {
        entryId: articleInfo.metadata.entryId,
        language: locale,
        country: this.props.country.toUpperCase(),
        locale: locale,
        request_type: 'VIEWCONTENT',
        entryTemplateId: 'BRCContent',
        docId: articleInfo.metadata.documentId,
        request_sub_type: 'VS',
        tenantId: 'BRC',
        request_status: 'Success',
        department: articleInfo.metadata.category[0],
      };
      axios
        .post('articleReview', {
          eventParams: body,
          _csrf: ArticleMainComponent.getCSRFToken(),
        })
        .then(function () {
          self.showMessage();
        })
        .catch(function () {});
    }
  }

  render() {
    const topicsHash = JSON.parse(this.props.topicsHash);
    const articleInfo = JSON.parse(this.props.articleInfo);
    const popArticlesHomeInfo = JSON.parse(this.props.popArticlesHomeInfo);
    const isRatingEnabled = JSON.parse(this.props.isRatingEnabled);
    const legalFooter = JSON.parse(this.props.legalFooter);
    const isPopArticleEnabled = JSON.parse(this.props.isPopArticleEnabled);
    const isHomeBreadcrumbEnabled = JSON.parse(
      this.props.isHomeBreadcrumbEnabled,
    );
    const {
      locale,
      country,
      isLoggedIn,
      isNewMppEnabled,
      helpContainer,
      gatewayInfo,
      isECMLive,
    } = this.props;

    const {
      ['gateway-pardot-url']: gatewayPatdotUrl,
      ['allow-lead-capture']: allowLeadCapture,
      ['leadCapture-pardot-url']: articleLeadCapturePatdorUrl,
    } = articleInfo?.content || {};

    const pardotURLForSelectedSlugId = getPardotUrlForSelectedSlugId({
      country: country.toLowerCase(),
      locale,
      slugId: articleInfo.content['url-slug'],
    });

    const leadCapturePatdotUrl =
      articleLeadCapturePatdorUrl || pardotURLForSelectedSlugId;
    const isPodcast = isTypePodcast(gatewayInfo['new-user-title']);
    const cookieAvailable =
      this.state.cookies && this.state.cookies.includes('gatewayForm');
    const showLeadForm = allowLeadCapture === 'Y';
    const countryCheck =
      country.toLowerCase() === 'us' || country.toLowerCase() === 'ca';
    const { urlPath } = this.state;

    const isPardotTrueExist = isPardotTrueExistInUrl(urlPath);
    const isSlugIdExist = checkSlugIdExist({
      country: country.toLowerCase(),
      locale,
      slugId: articleInfo.content['url-slug'],
    });
    const isFormlessForm =
      isECMLive === 'true'
        ? isSlugIdExist &&
          showLeadForm &&
          isPardotTrueExist &&
          leadCapturePatdotUrl !== undefined
        : isSlugIdExist && showLeadForm && isPardotTrueExist;

    // const isFormlessForm = isSlugIdExist && articleInfo.content["allow-lead-capture"] === "Y" && isPardotTrueExist;
    const { breadCrumbs } = articleInfo;
    const isLargeEnterprise =
      country.toLowerCase() === 'us' &&
      breadCrumbs &&
      breadCrumbs.length !== 0 &&
      breadCrumbs[0].id &&
      breadCrumbs[0].id === 'enterprise-solutions'
        ? true
        : false;

    return (
      <div className="brcarticle-main-component">
        <Headercontainer
          country={country}
          locale={locale}
          isLoggedIn={isLoggedIn}
          isNewMppEnabled={isNewMppEnabled}
        />
        <ArticleHerocontainer
          locale={locale}
          country={country}
          articleInfo={articleInfo}
        />
        <div className="flex">
          <div className="social">
            <Socialcontainer
              name="Social"
              country={country}
              articleInfo={articleInfo}
              id="socialmedia-share"
            />
          </div>
          <div
            className={`${
              !cookieAvailable && showLeadForm && countryCheck
                ? 'lead_form_available'
                : ''
            } middle`}
          >
            <Breadcrumbcontainer
              articleInfo={articleInfo}
              country={country}
              locale={locale}
              isHomeBreadcrumbEnabled={isHomeBreadcrumbEnabled}
            />
            <ArticleHeadercontainer
              locale={locale}
              country={country}
              articleInfo={articleInfo}
            />
            <Socialcontainer
              name="Social"
              country={country}
              articleInfo={articleInfo}
              id="socialmedia-share-mobile"
            />
            <div className="gatewayContent">
              <Podcast gatewayInfo={gatewayInfo} />
              <ArticleMaincontainer
                leadFormKey={allowLeadCapture}
                articleInfo={articleInfo}
                isPardotTrueExist={isPardotTrueExist}
                isSlugIdExist={isSlugIdExist}
                leadCapturePatdotUrl={leadCapturePatdotUrl}
                isECMLive={isECMLive}
              />
              <GatewayForm
                country={country}
                userAccountInfo={this.props.userAccountInfo}
                leadFormKey={allowLeadCapture}
                encryptedAccountNumber={this.props.encryptedAccountNumber}
                leadCapturePatdotUrl={leadCapturePatdotUrl}
                isPardotTrueExist={isPardotTrueExist}
                isFormlessForm={isFormlessForm}
                pardotURLForSelectedSlugId={pardotURLForSelectedSlugId}
                isECMLive={isECMLive}
              />
              {isFormlessForm ? (
                <FormLessForm
                  country={country}
                  locale={locale}
                  slugId={articleInfo.content['url-slug']}
                  pdtmail={this.state.pdtmail}
                />
              ) : (
                <GatewayDownload
                  country={country}
                  locale={locale}
                  gatewayInfo={gatewayInfo}
                  pdfKey={articleInfo.content['allow-pdf-download']}
                  slugId={articleInfo.content['url-slug']}
                  userAccountInfo={this.props.userAccountInfo}
                  encryptedAccountNumber={this.props.encryptedAccountNumber}
                  isECMLive={isECMLive}
                  gatewayPatdotUrl={gatewayPatdotUrl}
                />
              )}
            </div>
            <ArticleFootNotecontainer
              articleInfo={articleInfo}
              isSlugIdExist={isSlugIdExist}
              isPardotTrueExist={isPardotTrueExist}
              leadFormKey={allowLeadCapture}
              leadCapturePatdotUrl={leadCapturePatdotUrl}
              isECMLive={isECMLive}
            />
            <ArticleRating
              isRatingEnabled={isRatingEnabled}
              country={country}
              locale={locale}
              articleInfo={articleInfo}
            />
            <Faqcomponent country={country} articleInfo={articleInfo} />
          </div>
          <div className="rt">
            <SidePanelcomponent articleInfo={articleInfo} country={country} />
            {isPopArticleEnabled &&
            Array.isArray(popArticlesHomeInfo) &&
            !isPodcast ? (
              <MostPopularArticles
                articleInfo={articleInfo}
                popArticlesHomeInfo={popArticlesHomeInfo}
                locale={locale}
                country={country}
              />
            ) : (
              ''
            )}
          </div>
        </div>
        <Relatedstories
          articleInfo={articleInfo}
          locale={locale}
          topicsHash={topicsHash}
          country={country}
        />
        <Helpcontainer
          helpContainer={helpContainer}
          locale={locale}
          country={country}
        />
        <LegalFooter
          country={country}
          locale={locale}
          legalFooter={legalFooter}
        />
        <Footercontainer
          country={country}
          locale={locale}
          isNewMppEnabled={isNewMppEnabled}
        />
        <Scrollupcontainer />
      </div>
    );
  }
}

export default ArticleMainComponent;

ArticleMainComponent.propTypes = {
  articleInfo: PropTypes.string,
  topicsHash: PropTypes.string,
  country: PropTypes.string,
  popArticlesHomeInfo: PropTypes.string,
  isHomeBreadcrumbEnabled: PropTypes.string,
  isLoggedIn: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
};
